/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import "./GuestNotice.css";

/**
 * "You're browsing as a guest", at the top of the workspace for a signed-out
 * individual (CP-336).
 *
 * A guest could already give one-time without an account; nothing said so,
 * and nothing said what signing in adds. This does both, with the way in.
 */
class GuestNotice extends Component {
  render() {
    const notice = this.props.notice;
    if (!notice) {
      return null;
    }
    return (
      <div className="Marketplace-GuestNotice" role="note">
        <span className="Marketplace-GuestNotice-tag">{notice.tag}</span>
        <span className="Marketplace-GuestNotice-body">{notice.body}</span>
        <div
          className="Marketplace-GuestNotice-signIn"
          role="button"
          tabIndex={0}
          onClick={notice.signIn}
          onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && notice.signIn()}
        >
          {notice.signInLabel}
        </div>
      </div>
    );
  }
}

GuestNotice.propTypes = {
  notice: PropTypes.shape({
    tag: PropTypes.string,
    body: PropTypes.string,
    signInLabel: PropTypes.string,
    signIn: PropTypes.func,
  }),
};

export default GuestNotice;
